import { RefObject, useEffect } from 'react';
import { useDebouncedCallback } from './useDebounceCallback';

export default function useCenteredCarousel(ref: RefObject<HTMLElement | null>) {
    const onResize = useDebouncedCallback(() => {
        const element = ref.current;
        if (!element) return;

        const computedStyle = window.getComputedStyle(element);
        const width =
            element.clientWidth - parseFloat(computedStyle.paddingLeft) - parseFloat(computedStyle.paddingRight);

        if (width > (element.parentElement?.clientWidth || 0)) {
            element.style.removeProperty('left');
            element.style.removeProperty('margin-left');
            element.style.removeProperty('padding');
        } else {
            element.style.left = '50%';
            element.style.marginLeft = `-${width / 2}px`;
            element.style.padding = '0';
        }
    }, 100);

    useEffect(() => {
        window.addEventListener('resize', onResize);
        onResize();

        return () => {
            window.removeEventListener('resize', onResize);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
